import axiosInstance from "config/AxiosConfig";
import {
  RunnerEngineListResp,
  RunnerEngineDetailResp,
} from "domain/payload/response/runnerEngineResp/RunnerEngineResp";
import { RunnerEngineCreateReq } from "domain/payload/request/runnerEngine/RunnerEngineCreateReq";
import { RunnerEngineUpdateReq } from "domain/payload/request/runnerEngine/RunnerEngineUpdateReq";
import { BaseResponse } from "domain/payload/response/BaseResponseDto";

const RunnerEngineService = () => {
  const runnerEngineList = async (
    token: string,
    page?: number,
    size?: number,
    search?: string | null
  ): Promise<BaseResponse<RunnerEngineListResp[]>> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/runner-engine/list`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            page: page,
            size: size,
            search: search,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const runnerEngineDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<RunnerEngineDetailResp>> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/runner-engine/detail`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const runnerEngineCreate = async (
    token: string,
    request: RunnerEngineCreateReq
  ): Promise<RunnerEngineDetailResp> => {
    try {
      const response = await axiosInstance.post(
        `/v1/legacy/cms/runner-engine/create`,
        request,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const runnerEngineUpdate = async (
    token: string,
    request: RunnerEngineUpdateReq
  ): Promise<RunnerEngineDetailResp> => {
    try {
      const response = await axiosInstance.put(
        `/v1/legacy/cms/runner-engine/update`,
        request,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const runnerEngineDelete = async (
    token: string,
    id: string
  ): Promise<RunnerEngineDetailResp> => {
    try {
      const response = await axiosInstance.delete(
        `/v1/legacy/cms/runner-engine/delete`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const runnerEngineExecute = async (
    token: string,
    id: string
  ): Promise<RunnerEngineDetailResp> => {
    try {
      const response = await axiosInstance.post(
        `/v1/legacy/cms/runner-engine/execute`,
        null, 
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id } 
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };


  const runnerEngineHistoryList = async (
    token: string,
    page?: number,
    size?: number,
    search?: string | null
  ): Promise<BaseResponse<RunnerEngineListResp[]>> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/runner-engine/history`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            page: page,
            size: size,
            search: search,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  return { runnerEngineList, runnerEngineDetail, runnerEngineCreate, runnerEngineUpdate, runnerEngineDelete, runnerEngineHistoryList, runnerEngineExecute };
};

export default RunnerEngineService;
